import YamazumiReportsPage from './YamazumiReport/YamazumiReportsPage';
import BiReportsPage from './BiReport/BiReportsPage';

export default { YamazumiReportsPage , BiReportsPage };
